import createReactComponent from '../createReactComponent';
export default createReactComponent('outline', 'percentage-0', 'IconPercentage0', [["path",{"d":"M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0","key":"svg-0"}]]);